import { useQuery } from '@apollo/client'

import { OPERATION_FIND_SITE_UNSCOPED } from './operations-gql/queries'
import { SiteUnscopeDetail } from './types'

type FindSiteUnscopeData = {
  site: SiteUnscopeDetail | null
}

const useSiteUnscope = (id?: string) => {
  const { data, loading, error } = useQuery<FindSiteUnscopeData>(OPERATION_FIND_SITE_UNSCOPED, {
    variables: { id },
    skip: !id
  })

  return {
    site: data?.site ?? null,
    loading,
    error
  }
}

export default useSiteUnscope
